export default __webpack_public_path__ + "5f8a7f845b401e19653eb168d5987f8f.png";